export default __webpack_public_path__ + "static/media/elevate-blk-3.669c7ba6.png";